import { render, staticRenderFns } from "./success.component.vue?vue&type=template&id=4d40f553&scoped=true"
import script from "./success.component.vue?vue&type=script&lang=js"
export * from "./success.component.vue?vue&type=script&lang=js"
import style0 from "./success.component.vue?vue&type=style&index=0&id=4d40f553&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d40f553",
  null
  
)

export default component.exports